import { Action } from 'redux';

import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { editView } from '../../../actions/spaces/EditViewAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditViewAction: IEntityAction<IContentInfo, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editView_action,
  isVisible: () => true,
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => {
    return editView(targetItems[0]);
  }
};
